import React, { BaseSyntheticEvent } from 'react'
import {
  IonList,
  IonItem,
  IonCol,
  IonRow,
  IonLabel,
  IonContent,
  IonSplitPane,
  IonButton,
  IonFooter,
} from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { getCompleteChartSelector, getSignerListSelector } from '../../selectors'
import useDeviceMetrics from '../../../../utilities/useDeviceMetrics'
import { CompleteChartConstants } from '../../store/completeChart.constants'
import { setSelectedOption } from '../../store/completeChart.actions'
import AllErrorsCleared from '../../component/AllErrorsCleared.component'
import ErrorsAndWarningsList from '../../component/ErrorsAndWarningsList.component'
import ButtonGroupsWithHelperText from '../../component/ButtonGroupsWithHelperText.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../../components/tabs/Tabs.constants'
import '../CompleteChart.page.css'
import { getRulesSelector } from '../../../rules/selectors'
import useAreAllWarningsCleared from '../../hooks/useAreAllWarningsCleared.hook'
import useAreAllErrorsCleared from '../../hooks/useAreAllErrorsCleared.hook'
import { getServiceConfigSelector } from '../../../configurations/selectors/serviceConfig.selector'

const CompleteChartTablet = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { isTablet } = useDeviceMetrics()
  const { selectedOption } = useSelector(getCompleteChartSelector)
  const history = useHistory()
  const allWarningsCleared = useAreAllWarningsCleared()
  const allErrorsCleared = useAreAllErrorsCleared()
  const { PR_SIGNATURES } = useSelector(getServiceConfigSelector)

  const rulesState = useSelector(getRulesSelector)
  const { groupedRulesErrors } = rulesState

  const signerData = useSelector(getSignerListSelector)

  const errorsWarningsCount = (eType: string) => {
    return Object.values(groupedRulesErrors)
      .flat()
      .filter((error) => error.errorType === eType).length
  }

  const navigateToErrors = (e: BaseSyntheticEvent) => {
    dispatch(setSelectedOption(CompleteChartConstants.SET_ERRORS_TAB))
  }

  const navigateToWarnings = (e: BaseSyntheticEvent) => {
    dispatch(setSelectedOption(CompleteChartConstants.SET_WARNINGS_TAB))
  }

  const isRowSelected = (rowName: string): boolean => {
    return isTablet && selectedOption === rowName
  }

  const onSignaturePage = () => {
    history.push(TabConstants.SIGNER_TAB)
  }

  const verifiedCount = signerData?.filter((item) => item.verified === true).length

  return (
    <IonContent color='light'>
      <IonSplitPane when='md' className='no-scroll'>
        <div className='flex-column-space-between'>
          <IonList>
            <IonItem
              data-testid='errors-tab'
              onClick={navigateToErrors}
              className={isRowSelected(CompleteChartConstants.SET_ERRORS_TAB) ? 'aqua-base' : ''}>
              <IonCol className='ion-padding'>
                <IonRow>
                  <IonLabel color='dark'>
                    <h2>
                      {t('completeChart.errors')} ({errorsWarningsCount('error')})
                    </h2>
                  </IonLabel>
                </IonRow>
                <IonRow>
                  <IonLabel color='medium'>
                    <h3>{t('completeChart.errorsDescription')}</h3>
                  </IonLabel>
                </IonRow>
              </IonCol>
            </IonItem>

            <IonItem
              data-testid='warnings-tab'
              onClick={navigateToWarnings}
              className={isRowSelected(CompleteChartConstants.SET_WARNINGS_TAB) ? 'aqua-base' : ''}>
              <IonCol className='ion-padding'>
                <IonRow>
                  <IonLabel color='dark'>
                    <h2>
                      {t('completeChart.warnings')} ({errorsWarningsCount('warning')})
                    </h2>
                  </IonLabel>
                </IonRow>
                <IonRow>
                  <IonLabel color='medium'>
                    <h3>{t('completeChart.warningsDescription')}</h3>
                  </IonLabel>
                </IonRow>
              </IonCol>
            </IonItem>
          </IonList>
          {PR_SIGNATURES !== 0 && (
            <IonButton
              id={verifiedCount > 0 ? 'signature-tab-button-success' : 'signature-tab-button'}
              className={verifiedCount > 0 ? 'sc-success-bold' : 'sc-danger-bold'}
              slot='end'
              expand='block'
              onClick={onSignaturePage}>
              {t('completeChart.signatures')} ({verifiedCount}){' '}
            </IonButton>
          )}
        </div>
        <div className='available-full-width'>
          <IonContent
            id='ia-main-content ion-no-padding'
            className={allWarningsCleared && allErrorsCleared ? 'no-scroll' : ''}
            color='light'>
            <AllErrorsCleared />
            <ErrorsAndWarningsList />
            <IonFooter className='fixed-bottom-button-group-helper-text'>
              <ButtonGroupsWithHelperText />
            </IonFooter>
          </IonContent>
        </div>
      </IonSplitPane>
    </IonContent>
  )
}

export default CompleteChartTablet
